/* eslint-disable @next/next/no-img-element -- Source MLS badge must load from their API; not suitable for next/image caching */
import React, { useSyncExternalStore } from 'react';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

type SourceMlsBadgeProps = {
  sourceMlsUrl: string;
};

function subscribeToPageUrl(onStoreChange: () => void) {
  window.addEventListener('popstate', onStoreChange);
  return () => {
    window.removeEventListener('popstate', onStoreChange);
  };
}

function getPageUrlSnapshot() {
  return window.location.href;
}

function getServerPageUrlSnapshot() {
  return '';
}

function useCurrentPageUrl(): string {
  return useSyncExternalStore(subscribeToPageUrl, getPageUrlSnapshot, getServerPageUrlSnapshot);
}

/**
 * Displays the Source MLS verifcation badge as in: https://www.sourcemls.org/developers#for-licensees
 */
export function SourceMlsBadge({ sourceMlsUrl }: SourceMlsBadgeProps) {
  const { t } = useTranslation(Namespaces.COMMON);
  const pageUrl = useCurrentPageUrl();

  if (!pageUrl) {
    return null;
  }

  const src = `${sourceMlsUrl}.png?loc=${encodeURIComponent(pageUrl)}`;

  return (
    <img
      src={src}
      width={132}
      height={60}
      alt={t(LOCALE_COMMON_PATHS.PROVIDER_DISCLAIMER_SOURCE_MLS_VERIFIED, { defaultValue: 'Source MLS Verified' })}
    />
  );
}
